import styled from "styled-components";
import WarningAmber from "@mui/icons-material/WarningAmber";
import colors from "@/main/style/colors";

const MODAL_SIDE_TITLE_HEIGHT = "3.75rem";

export const TitleRow = styled.span`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 0.5rem;
`;

export const ClaimInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.125rem;
	font-size: 0.875rem;
	color: ${({ theme }) => theme?.neutral?.n600 || colors.neutral.n600};
	font-weight: 400;
`;

export const ClaimInfoValue = styled.strong`
	font-weight: 700;
	color: ${({ theme }) => theme?.black || colors.black};
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: calc(100% - ${MODAL_SIDE_TITLE_HEIGHT});
	padding: 0 1rem 1rem;
	position: relative;
	overflow-y: hidden;
`;

export const LoadingWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 1;
`;

export const LoaderContainer = styled.div`
	display: flex;
	justify-content: center;
	padding: 1rem 0;
`;

export const EmptyWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 1;
	padding: 2rem;
	border: 0.0625rem dashed ${({ theme }) => theme?.grayDark || colors.grayDark};
	border-radius: 0.5rem;
	margin-top: 0.5rem;
`;

export const EmptyText = styled.p`
	color: ${({ theme }) => theme?.neutral?.n600 || colors.neutral.n600};
	text-align: center;
	margin: 0;
	font-size: 0.9rem;
`;

export const ErrorWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex: 1;
	padding: 2rem;
	border: 0.0625rem dashed ${({ theme }) => theme?.orange || colors.orange};
	background-color: ${({ theme }) => theme?.figma?.alert?.light || colors.figma.alert.light};
	border-radius: 0.5rem;
	margin-top: 0.5rem;
`;

export const ErrorIcon = styled(WarningAmber)`
	&& {
		color: ${({ theme }) => theme?.orange || colors.orange};
		font-size: 2rem;
		margin-bottom: 0.5rem;
	}
`;

export const ErrorText = styled.p`
	color: ${({ theme }) => theme?.errorDark || colors.errorDark};
	text-align: center;
	margin: 0;
	font-size: 0.9rem;
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	overflow-y: auto;
	gap: 1rem;
	margin-top: 0.5rem;
`;

export const Footer = styled.div`
	display: flex;
	justify-content: center;
	padding-top: 1rem;
	margin-top: auto;
`;
